export const FormField = {
  comment: 'comment',
  files: 'files',
  visibleFor: 'visibleFor',
} as const;
